import { X } from "lucide-react";

interface FilterChipsProps {
  label: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
  allLabel?: string;
  formatValue?: (value: string) => string;
}

/**
 * Reusable chip-based filter component
 */
export function FilterChips({
  label,
  options,
  selected,
  onToggle,
  onClear,
  allLabel,
  formatValue,
}: FilterChipsProps) {
  const isAllSelected = selected.length === 0;
  const format = formatValue || ((v: string) => v);

  return (
    <div className="filter-chips__container">
      <span className="filter-chips__label">{label}:</span>
      <div className="filter-chips">
        <button
          className={`chip ${isAllSelected ? "chip--selected" : ""}`}
          onClick={onClear}
          type="button"
        >
          {allLabel || `All ${label}s`}
        </button>
        {options.map((option) => (
          <button
            key={option}
            className={`chip ${selected.includes(option) ? "chip--selected" : ""
              }`}
            onClick={() => onToggle(option)}
            type="button"
          >
            {format(option)}
          </button>
        ))}
        {!isAllSelected && (
          <button
            className="filter-chips__clear"
            onClick={onClear}
            type="button"
            aria-label={`Clear ${label.toLowerCase()} filters`}
          >
            <X aria-hidden />
            <span>Clear</span>
          </button>
        )}
      </div>
    </div>
  );
}
